import { NUMBER } from '../fields/constants'
import { FormRecord } from '../types'
import { getKey } from './get-key'

export const buildInitialValues = (formRecord: FormRecord) => {
  let initialValues = {
    form: '', // ustawiamy to pole by móc tam wpakować ogólne błędy formularza, np. że formularz nie jst opublikowany
  }
  formRecord.formSpec.fields.map((field, i) => {
    const key = getKey(i)
    if (!!field.multiple) {
      initialValues[key] = []
    } else if (field.type === NUMBER) {
      initialValues[key] = 0
    } else {
      initialValues[key] = ''
    }
  })

  return initialValues
}
